import Providers from './Providers';
import Router from './Router';

const App = () => {
  return (
    <Providers>
      <Router />
    </Providers>
  );
};

export default App;
